import React, { useState } from "react";
import { FaBars } from "react-icons/fa";
import { HiX } from "react-icons/hi";
import { Link } from "react-router-dom";
import { GrLinkedin } from "react-icons/gr";
import { RiGithubFill, RiLinkedinFill, RiTwitterXFill} from "react-icons/ri";
import "./styles.scss";
const data = [
  
  {
    label: "HOME",
    to: "/",
  },
  {
    label: "ABOUT ME",
    to: "/about",
  },
  {
    label: "SKILLS",
    to: "/skills",
  },
  {
    label: "PORTFOLIO",
    to: "/portfolio",
  },
  {
    label: "RESUME",
    to: "https://drive.google.com/file/d/1tAT3ckGiENNbMqtzd8Cf01dM_Obd-50z/view",
  },
  {
    label: "CONTACT",
    to: "/contact",
  },
];

const Navbar = () => {
  const [toggleIcon, setToggleIcon] = useState(false);

  const handleToggleIcon = () => {
    setToggleIcon(!toggleIcon);
  };
  const closeMenu = () => {
    setToggleIcon(false);
  };
  return (
    <div>
      <nav className="navbar">
        <div className="navbar__container">
        
        <div className="navbar__container__social1">
          <a href="https://twitter.com/amit_XV">
            <RiTwitterXFill
              className="navbar__container__social1__it"
              size={20}
              color="var(--aqua-theme-main-color)"
            />
          </a>
          <a href="https://www.linkedin.com/in/amit-giri72/">
            <RiLinkedinFill
              className="navbar__container__it"
              size={20}
              color="var(--aqua-theme-main-color)"
            />
          </a>
          <a href="https://github.com/amitgiri72">
            <RiGithubFill
              className="navbar__container__it"
              size={20}
              color="var(--aqua-theme-main-color)"
            />
          </a>
        </div>
        </div>
        <ul
          className={`navbar__container__menu ${toggleIcon ? "active" : ""} `}
        >
          {data.map((item, key) => (
            <li key={key} className="navbar__container__menu__item">
              <Link
                className="navbar__container__menu__item__links"
                to={item.to}
                onClick={closeMenu}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
        <div className="nav-icon" onClick={handleToggleIcon}>
          {toggleIcon ? <HiX size={30} /> : <FaBars size={30} />}
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
